// Input: Date -> Output: dd/mm/yyyy
export const formatDate = (selectedDia: Date) => {
  const selected = new Date(selectedDia)
  const day = selected.getDate()
  const month = selected.getMonth() + 1
  const year = selected.getFullYear()
  return `${day}/${month}/${year}`
}

// Input: Date -> Output: dd-mm-yyyy
export const formatDateGuion = (selectedDia: Date): string => {
  if (selectedDia) {
    const selected = new Date(selectedDia)
    const day = selected.getDate().toString().padStart(2, '0')
    const month = (selected.getMonth() + 1).toString().padStart(2, '0') // devuelve el mes con un cero adelante si es menor a 10
    const year = selected.getFullYear()
    return `${day}-${month}-${year}`
  } else {
    return ''
  }
}

// Input: Date -> Output: yyyy-mm-dd
export const formatDateApi = (selectedDia: Date): string => {
  if (selectedDia) {
    const selected = new Date(selectedDia)
    const day = selected.getDate().toString().padStart(2, '0')
    const month = (selected.getMonth() + 1).toString().padStart(2, '0') // devuelve el mes con un cero adelante si es menor a 10
    const year = selected.getFullYear()
    return `${year}-${month}-${day}`
  } else {
    return ''
  }
}

// Input: dd-mm-yyyy -> Output: yyyy-mm-dd
export const convertDateFormat = (input: string): string => {
  const [day, month, year] = input?.split("-") ?? formatDateGuion(new Date())
  return `${year}-${month}-${day}`
}

// Formatear fecha para el search
export const formatFakeDate = (selectedDia: Date): string => {
  const selected = new Date(selectedDia)
  const day = selected.getDate()
  const month = selected.getMonth()
  const monthChar = new Date(0, month).toLocaleString('default', { month: 'short' })?.substring(0, 3)
  const capitalizedMonth = monthChar?.charAt(0).toUpperCase() + monthChar?.slice(1)
  return `${day} ${capitalizedMonth}.`
}

// Obtener si es de 12 o 24 horas
export const changeHourFormat = (idioma: string): boolean => {
  const format = new Intl.DateTimeFormat(idioma, { hour: 'numeric' }).resolvedOptions().hourCycle
  if (format === 'h11' || format === 'h12') {
    return true
  }
  return false
}

// Input HH:mm -> Output HH:mm AM/PM
export const format12Hour = (time: string): string => {
  if (!time || typeof time !== 'string') return ''
  const [hoursStr, minutes] = time.split(':')
  if (hoursStr === undefined || minutes === undefined) return ''
  const hours = parseInt(hoursStr, 10)
  if (isNaN(hours)) return ''
  const hour12 = ((hours % 12) || 12).toString().padStart(2, '0')
  return `${hour12}:${minutes} ${hours < 12 ? 'AM' : 'PM'}`
}
export const getCookieDate = (fechaGuion: string): Date => {
  const hoyNormalizado = new Date(new Date().setHours(12, 0, 0, 0))

  if (!fechaGuion.match(/^\d{2}-\d{2}-\d{4}$/)) { // verificar que la fecha tenga el formato dd-mm-yyyy
    return hoyNormalizado
  }
  const dateString: any = fechaGuion
  const dateParts = dateString?.split("-")
  const mifecha = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0], 12, 0, 0)

  if (mifecha < hoyNormalizado) { // verificar que la fecha es menor que hoy
    return hoyNormalizado
  }

  return mifecha
}

// Input HH:mm -> Output { horaFormateada: string, cambioDia: boolean }
export const sumHours = (hora: string, incremento: number): { horaFormateada: string, cambioDia: boolean } => {
  // Extraemos la hora como número
  const [horasStr] = hora.split(":")
  const horas = parseInt(horasStr || '0', 10)

  // Sumamos las horas y calculamos si hay cambio de día
  const nuevaHora = (horas + incremento) % 24
  const cambioDia = horas + incremento >= 24

  // Formateamos la hora con dos dígitos
  const horaFormateada = nuevaHora.toString().padStart(2, '0')

  return { horaFormateada: `${horaFormateada}:00`, cambioDia }
}

// Input: yyyy-mm-dd -> Output: Date
export const convertToDate = (input: string): Date => {
  const [year, month, day] = input.split('-').map(Number)
  return new Date(year || 0, (month || 0) - 1, (day || 0), 12, 0, 0) // Los meses en JavaScript son de 0 a 11
}

// Input: Date -> Output: Date + 1 day
export const addOneDay = (input: Date): Date => {
  const date = new Date(input)
  date.setDate(date.getDate() + 1)
  return date
}

// Input: HH:mm:ss -> Output: HH:mm
export const formatTime = (timeStr: string): string => {
  if (!timeStr) return ''
  const formatted = timeStr.replace(/(\d{2})(\d{2})(\d{2})/, '$1:$2')
  return formatted
}

// Input: HH:mm, number, number, string -> Output: { hour: string, day: string }
export const calculateCheckOut = (checkIn: string, hours: number, extraHours: number, date: string): { hour: string, day: string } => {
  if (!checkIn) return { hour: '', day: '' }
  const time = formatTime(checkIn)
  const [hStr, mStr] = time.split(':')
  const h = Number(hStr)
  const m = Number(mStr)
  if (isNaN(h) || isNaN(m)) {
    return { hour: '', day: '' }
  }
  if (isNaN(extraHours)) return { hour: '', day: '' }

  const checkInMinutes = h * 60 + m
  const extraMinutes = Math.round(extraHours * 60)
  const checkOutMinutesTotal = checkInMinutes + (hours * 60) + extraMinutes

  const minutesPerDay = 24 * 60

  const passedDays = Math.floor(checkOutMinutesTotal / minutesPerDay)
  const dateFormatCheckout = getCookieDate(date || '')
  const newDateFormatCheckout = passedDays ? dateFormatCheckout.setDate(dateFormatCheckout.getDate() + passedDays) : dateFormatCheckout
  const checkoutDateFormatted = new Date(newDateFormatCheckout)

  const normalized = ((checkOutMinutesTotal % minutesPerDay) + minutesPerDay) % minutesPerDay

  const checkOutHours = Math.floor(normalized / 60)
  const checkOutMins = normalized % 60

  return {
    hour: `${checkOutHours.toString().padStart(2, '0')}:${checkOutMins.toString().padStart(2, '0')}`,
    day: formatDateGuion(checkoutDateFormatted)
  }
}